import { createContext } from 'react';

export interface PanelInstanceContextType {
  title: string;
  setTitle: (title: string) => void;
  uniqueId: string;
  bounds: string | Element | undefined;
  panelTogglePopout: () => void;
  panelClose: () => void;
  setPanelWindow: (w: Window) => void;
  bringPanelToFront: () => void;
  panelPoppedOut: boolean;
  zIndex: number;
  dockId: string | undefined;
  docked: boolean;
  dock: (id: string) => void;
  undock: () => void;
  hidden?: boolean;
}

const NoContextError = () => {
  console.error('Missing PanelInstanceContext Provider');
};

/**
 * Provides access to closing/popping panels
 */
export const PanelInstanceContext = createContext<PanelInstanceContextType>({
  title: 'Missing PanelInstanceContext Provider: title',
  uniqueId: 'Missing PanelInstanceContext Provider: uniqueId',
  bounds: document.body,
  setTitle: NoContextError,
  panelTogglePopout: NoContextError,
  panelClose: NoContextError,
  setPanelWindow: NoContextError,
  bringPanelToFront: NoContextError,
  dock: NoContextError,
  undock: NoContextError,
  docked: false,
  dockId: undefined,
  panelPoppedOut: false,
  zIndex: 0,
  hidden: false,
});
